<template>
  <div class="main">
    <customHeader title="修改密码"></customHeader>

    <!--修改密码主体-->
    <div class="cpwds">
      <!-- <input class="txt txt1" type="password" v-model="ypwd" :placeholder="$t('changepwd.placeholder_txt1')" /> -->
      <input
        class="txt txt2"
        type="password"
        v-model="npwd1"
        :placeholder="$t('changepwd.placeholder_txt2')"
      />
      <input
        class="txt txt3"
        type="password"
        v-model="npwd2"
        :placeholder="$t('changepwd.placeholder_txt3')"
      />
      <div class="threbtn fs28 orangeToYellow" @click="doSavePwd">
        {{ $t('changepwd.sure') }}
      </div>
    </div>
    <!--修改密码主体 end-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      ypwd: '',
      npwd1: '',
      npwd2: '',
    }
  },
  created() {},
  methods: {
    doSavePwd() {
      var ypwd = this.ypwd
      var npwd1 = this.npwd1
      var npwd2 = this.npwd2
      // if(this.$isblank(ypwd)){
      //     this.$toast("请输入当前密码");return false;
      // }
      if (this.$isblank(npwd1)) {
        this.$toast('请输入新的密码')
        return false
      } else if (npwd1.length < 6) {
        this.$toast('密码最少输入6位')
        return false
      } else if (this.$isblank(npwd2)) {
        this.$toast('请确认新的密码')
        return false
      } else if (npwd1 != npwd2) {
        this.$toast('两次密码输入不一致')
        return false
      }

      var _this = this
      this.$api
        .doChangePwd({
          // newPwd: _this.$md5(npwd2),
          newPwd: npwd2,
        })
        .then((res) => {
          // 修改成功后退出并回到登录页面
          this.$toast.success('修改密码成功，请重新登录')
          this.$api.outLogin().then(() => {
            localStorage.removeItem('token')
            this.$router.push('/login')
          })
        })
    },
  },
}
</script>

<style>
/*文本框主体*/
.cpwds {
  width: 6.6rem;
  margin: 0 auto;
  padding-top: 1.2rem;
}
.cpwds .txt {
  width: 100%;
  padding: 0.33rem 0;
  text-indent: 0.38rem;
  background: #f4f4f4;
  border-radius: 0.15rem;
  margin-top: 0.2rem;
  font-size: 0.3rem;
  color: #333;
}
.threbtn {
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.1rem;
  text-align: center;
  color: #fff;
  margin-top: 0.66rem;
}
/*文本框主体 end*/
</style>
